// frontend/src/App.tsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CognitoUser } from 'amazon-cognito-identity-js'; // Import CognitoUser type
import CustomAuth from './components/CustomAuth';
import SpotifyCallback from './components/SpotifyCallback';
import SpotifyConnectButton from './components/SpotifyConnectButton';
import PlaylistPromptForm from './components/PlaylistPromptForm';
import PlaylistEditor from './components/PlaylistEditor';
import PlaylistConfirmation from './components/PlaylistConfirmation';
import './styles.css';

const App: React.FC = () => {
  const [cognitoUser, setCognitoUser] = useState<CognitoUser | null>(null); // Use CognitoUser type
  const [spotifyInfo, setSpotifyInfo] = useState<{ connected: boolean; profile: any | null }>({ connected: false, profile: null }); // Separate state for Spotify
  const [playlist, setPlaylist] = useState<Array<any>>([]);
  const [isConfirmed, setIsConfirmed] = useState(false);

  return (
    <Router>
      <Routes>
        {/* Spotify callback route */}
        <Route 
          path="/spotify-callback" 
          element={
            <SpotifyCallback 
              onSpotifyConnected={(spotifyProfile) => { // Receive Spotify profile
                console.log("Spotify connection successful in App, profile:", spotifyProfile);
                setSpotifyInfo({ connected: true, profile: spotifyProfile }); // Update Spotify state
              }} 
            />
          } 
        />

        {/* Main app route */}
        <Route 
          path="/" 
          element={
            <div className="App">
              <header className="App-header">
                <h1>
                  {cognitoUser ? `Welcome, ${cognitoUser.getUsername()}` : 'Spotify Inspired Playlist App'}
                </h1>
              </header>
              <main>
                {!cognitoUser && (
                  <CustomAuth onLogin={(user: CognitoUser) => setCognitoUser(user)} /> // Pass CognitoUser object
                )}
                {cognitoUser && !spotifyInfo.connected && ( // Check separate spotifyInfo state
                  <div>
                    <p>Connect your Spotify account to start creating playlists.</p>
                    <SpotifyConnectButton />
                  </div>
                )}
                {cognitoUser && spotifyInfo.connected && playlist.length === 0 && ( // Check separate spotifyInfo state
                  <PlaylistPromptForm onGenerate={setPlaylist} />
                )}
                {playlist.length > 0 && !isConfirmed && (
                  <PlaylistEditor 
                    playlist={playlist} 
                    onEdit={setPlaylist} 
                    onConfirm={() => setIsConfirmed(true)} 
                  />
                )}
                {isConfirmed && (
                  <PlaylistConfirmation playlist={playlist} />
                )}
              </main>
            </div>
          } 
        />
      </Routes>
    </Router>
  );
};

export default App;
